import { render, staticRenderFns } from "./DraggableDataTable.vue?vue&type=template&id=274b0f39&scoped=true&"
import script from "./DraggableDataTable.vue?vue&type=script&lang=ts&"
export * from "./DraggableDataTable.vue?vue&type=script&lang=ts&"
import style0 from "./DraggableDataTable.vue?vue&type=style&index=0&id=274b0f39&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274b0f39",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VDataTable})
